import { Element } from "./src/content";

// eslint-disable-next-line import/no-default-export
export default Element;
